;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { gql } from "@apollo/client"

// The dedicated endpoint applies exact geography and online eligibility before
// pagination, and includes therapy groups only. Legacy landing pages keep V2.
const searchGeographicLandingGroups = gql`
  query searchGeographicLandingGroups(
    $iState: String!
    $iScope: String!
    $iCities: [String]
    $first: Int
    $after: Cursor
  ) {
    searchGroupsPublicLanding(
      iState: $iState
      iScope: $iScope
      iCities: $iCities
      first: $first
      after: $after
    ) {
      edges {
        node {
          city
          cohortId
          cohortLocations
          cohortNextStartsAt
          groupDescription
          groupId
          groupPublicId
          groupVanitySlug
          groupName
          groupPhotoUrl
          groupType
          joinableCohortCount
          priceType
          priceValue
          providerFirstName
          providerLastName
          providerPhotoUrl
          providerPreferredFirstName
          providerPreferredLastName
          providerPrimaryCredential
          providerPrimaryRole
          providerTitle
          settingInPerson
          settingVirtual
          state
        }
        cursor
      }
      totalCount
      pageInfo {
        endCursor
        hasNextPage
      }
    }
  }
`

export default searchGeographicLandingGroups
